module.exports = __webpack_public_path__ + "img/HG.d82e9554.png";